<script>
import Base from './base.vue';
import { computedCallingPlans, computedPbxBasePlans } from '@/common/service/computers/plans/pbx';
import { BILLING_CYCLE } from '@/common/constants';
import { getZPCallingFeesText } from '@/plans/ZOOM_PHONE/helper/utils';
import { mapGetters } from 'vuex';
import { PBX_REGIONS } from '@/plans/ZOOM_PHONE/helper/constants';
import { bundleRegions } from '../helper';

export default {
  name: 'Upsell',
  extends: Base,
  computed: {
    ...mapGetters(['boughtPlans', 'basicConfig']),
    showCycle() {
      // if has purchased zp base plan, return false
      const basePlan = computedPbxBasePlans(this.boughtPlans)?.[0] ?? false;
      if (basePlan) {
        return false;
      }
      return true;

    },
    planBillInfo() {
      if (this.showCycle) return false;
      const plan = computedCallingPlans(this.boughtPlans)?.[0] ?? {};
      const basePlan = computedPbxBasePlans(this.boughtPlans)?.[0] ?? {};
      const payment = getZPCallingFeesText(basePlan).title;
      const billingCycle = basePlan.billing_cycle === BILLING_CYCLE.PAY_AS_YOU_GO ? BILLING_CYCLE.MONTHLY : plan.billing_cycle;
      return {
        billing_cycle: billingCycle,
        payment
      }
    },
    minCallingPlan() {
      return 1;
    },
    isBulkLicenseAccount() {
      return this.basicConfig?.isBulkLicenseAccount;
    },
    planDetailLabel() {
      if (this.isBulkLicenseAccount) return '';
      return this.$t('billing.plan_details');
    },
    currentBoughtBizPlusPlans() {
      return this.plansofBizBundle.boughtBizPlusPlan;
    },
    pbxRegions() {
      return bundleRegions.filter((x) => x.key === PBX_REGIONS.US_AND_CANADA);
    },
  }
}
</script>
